var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.model.text,"items":_vm.model.selection,"item-text":"selectionValue","item-value":"selectionKey","dense":""},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }